import { Card, CardVariant } from '@components/card';
import { BaseIcon } from '@components/icons/base';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

export type NoResultCardProps = {
  text: string;
  icon: typeof BaseIcon;
  variant?: CardVariant;
};

export const NoResultCard = ({ text, icon: Icon, variant }: NoResultCardProps) => (
  <Card variant={variant ?? 'gray'} spaceX={4} spaceY={4}>
    <Stack align="center" space={3} orientation="horizontal">
      <Icon color="buttonIconPositive" size={24} />
      <Text font="semibold14" color="textSecondary" text={text} />
    </Stack>
  </Card>
);
